<vwui-header>
    <vwui-badge class="badge badge--header badge--red"><i class="fas fa-exclamation-triangle"></i></vwui-badge>
    &nbsp;
    {{ "PAGE_NO_ACCESS.title" | translate }}
</vwui-header>
{{ 'PAGE_NO_ACCESS.message' | translate }}
